exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".collapse[data-v-4299380e]{display:none}.collapse.in[data-v-4299380e]{display:block}.collapsing[data-v-4299380e]{position:relative;height:0;overflow:hidden;transition:height .377s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4299380e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-bulma-expanding/src/Expanding.vue
// module id = 34
// module chunks = 4